var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1003 1.61699L27.0512 1.1094H23.2509V0.527354C23.2509 0.453198 23.2422 0.381626 23.2396 0.308044H3.8826C3.88145 0.381338 3.87139 0.453198 3.87139 0.527354V1.10968H0.0712819L0.0221319 1.61728C0.0106348 1.73713 0 1.85756 0 1.97944V7.01601C0 9.48959 2.45725 11.5016 5.47695 11.5016H5.73564C7.22941 13.5447 9.50263 14.9809 12.1188 15.3712V18.2469H7.31219L6.48815 28.8228H20.6356L19.8116 18.2469H15.0044V15.3712C17.62 14.9809 19.8935 13.5441 21.387 11.5016H21.6462C24.6665 11.5016 27.1237 9.48959 27.1237 7.01601V1.97944C27.1237 1.85728 27.1134 1.73713 27.101 1.61699H27.1003ZM4.91556 10.3504C2.77942 10.1368 1.12384 8.72326 1.12384 7.01595V2.23287H3.87137V5.78861C3.87137 7.36311 4.24933 8.84798 4.91556 10.1627V10.3504ZM26.0003 7.01624C26.0003 8.72326 24.3438 10.1377 22.2083 10.3507V10.1632C22.8745 8.84887 23.252 7.36341 23.252 5.78891V2.23317H26.0004L26.0003 7.01624Z",
    fill: "#132640"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.1cbb8e0e.svg";
export { ForwardRef as ReactComponent };